import { useState } from 'react';

const DEFAULT_FORM = {
  client: null,
  contractType: 'honorarios',
  honorarios: { type: 'percentual', percentual: '', exitoPercentual: '', fixo: '', minimo: '', observacao: '', objeto: '' },
  customClauses: [],
  notes: '',
};

export function useContractForm() {
  const [form, setForm] = useState(() => structuredClone(DEFAULT_FORM));

  return {
    form, setForm,
    DEFAULT_FORM,
  };
}
